import { render, staticRenderFns } from "./InactiveFBMUsersTable.vue?vue&type=template&id=4c8895f0&scoped=true"
import script from "./InactiveFBMUsersTable.vue?vue&type=script&lang=js"
export * from "./InactiveFBMUsersTable.vue?vue&type=script&lang=js"
import style0 from "./InactiveFBMUsersTable.vue?vue&type=style&index=0&id=4c8895f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8895f0",
  null
  
)

export default component.exports